export default function () {
  // There will be a JS-code for header
  console.log('header Code')
}



// WEBPACK FOOTER //
// ./scripts/components/header/init.js